import { Button } from '@/components/ui/button';
import type { BagDetail } from '../types';

type Props = {
  bag: BagDetail;
  onClose: () => void;
  onReopen: () => void;
  onQuote: () => void;
};

const getActiveItemsCount = (bag: BagDetail): number =>
  bag.sales
    .filter((s) => s.payment_status !== 'cancelled')
    .reduce((sum, s) => sum + s.sale_items.reduce((qty, i) => qty + i.quantity, 0), 0);

export const BagActionsBar = ({
  bag,
  onClose,
  onReopen,
  onQuote,
}: Props) => {
  if (bag.label_generated) {
    return null;
  }

  if (bag.status === 'aberta') {
    return (
      <div className="flex gap-2 flex-wrap">
        <Button onClick={onClose} variant="secondary">
          Fechar sacolinha
        </Button>
      </div>
    );
  }

  if (bag.status === 'fechada') {
    const itemsCount = getActiveItemsCount(bag);

    return (
      <div className="flex gap-2 flex-wrap">
        <Button onClick={onReopen} variant="outline">
          Reabrir
        </Button>
        <Button onClick={onQuote} disabled={itemsCount === 0}>
          Gerar cotação de frete
        </Button>
      </div>
    );
  }

  return null;
};
